import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function CheckEmail() {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || 'your email';

  return (
    <div className="container">
      <div className="card" style={{ maxWidth: '500px', margin: '50px auto', textAlign: 'center' }}>
        <div style={{ fontSize: '4rem', marginBottom: '20px' }}>📧</div>
        
        <h2 style={{ color: '#ff6b35', marginBottom: '24px' }}>
          Check Your Email
        </h2>
        
        <p style={{ fontSize: '18px', marginBottom: '20px', color: '#e0e0e0' }}>
          We've sent an activation link to:
        </p>
        
        <p style={{ 
          fontSize: '16px', 
          fontWeight: 'bold', 
          color: '#ff6b35',
          backgroundColor: 'rgba(255, 107, 53, 0.1)',
          padding: '12px',
          borderRadius: '8px',
          marginBottom: '30px',
          wordBreak: 'break-word'
        }}>
          {email}
        </p>
        
        <div style={{ 
          backgroundColor: 'rgba(52, 152, 219, 0.1)',
          border: '1px solid rgba(52, 152, 219, 0.3)',
          borderRadius: '8px',
          padding: '20px',
          marginBottom: '30px'
        }}>
          <h3 style={{ color: '#3498db', marginBottom: '15px', fontSize: '18px' }}>
            Next Steps:
          </h3>
          <ol style={{ 
            textAlign: 'left', 
            color: '#e0e0e0',
            paddingLeft: '20px',
            lineHeight: '1.6'
          }}>
            <li>Check your email inbox (and spam folder)</li>
            <li>Click the "Activate My Account" button in the email</li>
            <li>Return here to log in and start your free trial</li>
            <li>Complete the quick tutorial to learn the features</li>
          </ol>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ color: '#b0b0b0', fontSize: '14px', marginBottom: '15px' }}>
            Didn't receive the email? Check your spam folder or try again.
          </p>
          
          <button
            onClick={() => navigate('/login?mode=register')}
            style={{
              background: 'rgba(255, 107, 53, 0.2)',
              border: '1px solid #ff6b35',
              color: '#ff6b35',
              padding: '10px 20px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              marginRight: '10px'
            }}
          >
            Try Again
          </button>
          
          <button
            onClick={() => navigate('/login')}
            style={{
              background: 'none',
              border: '1px solid #666',
              color: '#b0b0b0',
              padding: '10px 20px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Back to Login
          </button>
        </div>
        
        <div style={{ 
          borderTop: '1px solid #333',
          paddingTop: '20px',
          marginTop: '30px'
        }}>
          <p style={{ color: '#666', fontSize: '12px' }}>
            The activation link will expire in 24 hours.
            <br />
            Need help? Contact us at info@duttonbiz.com
          </p>
        </div>
      </div>
    </div>
  );
}

export default CheckEmail;